import React from "react";
import "./Footer.scss";

export const Footer: React.FC = () => {
  return (
    <div className="app-footer">
      <div className="container">
        <div className="footer-title">
          <h1> <strong> Let's connect to the world.<br />Together.</strong></h1>
          </div>
        <div className="b-link">
          <a href="/privacy-policy.html">Privacy Policy</a>
        </div>
        <div className="b-link">
          <a href="/terms-of-use.html">Terms of Service</a>
        </div>
        <div className="t-copyright">© 2025 SuperTools All Rights Reserved. <div>Support: <a href="mailto:companysupertool@163.com">companysupertool@163.com</a></div></div>
      </div>
    </div>
  );
};
